import fetch from 'isomorphic-fetch'
import request from 'superagent'
import { eventChannel, END } from 'redux-saga'
import REGEXP from 'constant/REGEXP'

const apiHeaders = new Headers()
apiHeaders.append('X-Requested-With', 'XMLHttpRequest')

export const fetchApi = (endpoint, params = {}) => {
    const options = {
        method: 'GET',
        mode: 'cors',
        cache: 'default',
        headers: apiHeaders,
        credentials: 'include',
        params
    }
    /*TODO PARAMS*/
    if (__SERVER) endpoint = `http://127.0.0.1:${__SERVER_PORT}${endpoint}`

    endpoint += '?'
    for (let i in params) {
        endpoint += `${i}=${JSON.stringify(params[i])}&`
    }


    return fetch(endpoint, options)
    .then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
        if (!response.ok) return Promise.reject(json)
        return json
    })
    .then(
        response => ({ response }),
        error => ({ error })
    )
}

export const callApi = (endpoint, method, payload, files, entity) =>
    eventChannel(emit => {
        const req = request[method.toLowerCase()](endpoint)
        .set('X-Requested-With', 'XMLHttpRequest')
        //.set('Content-Type', 'application/json')
        if (payload) {
            for (let i in payload) {
                if (payload[i] && i !== '_id' && i !== 'id') req.field(i, payload[i])
            }
        }
        if (files) {
            for (let i in files) {
                req.attach('files', files[i])
            }
        }
        req.on('progress', function (e) {
            emit(entity.progress({ percent: e.percent }))
        })
        req.then((response) => { 
            emit(entity.success(response.body))
            emit(END)
        })
        req.catch((error) => {
            emit(entity.failure(error.response.body))
            emit(END)
        })
        return () => {
            
        }
    })

export const makeEndpoint = (endpoint, params = {}) => {
    let matches
    while (matches = REGEXP.path.params.exec(endpoint)) {
        const match = matches[1]
        let param = params[match]
        if (!param && match === 'id') param = params._id
        if (param) endpoint = endpoint.replace(`:${match}`, param)
        else if (__DEV) console.warn(`Make endpoint: param ${match} not found.`)
    }
    return endpoint
}


// WEBPACK FOOTER //
// ./src/client/core/api.js